// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField'
import {
    Autocomplete,
    Card,
    Divider,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
} from '@mui/material'
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2";
import moment from 'moment'
import DialogEditHargaJasa from '../../../components/production/DialogEditHargaJasa';
import DialogPencairanJasa from '../../../components/production/DialogPencairanJasa'
import DialogTambahBiaya from '../../../components/production/DialogTambahBiaya'
import DialogPiutang from '../../../components/production/DialogPiutang'
import React from 'react'
import { useRef } from "react"
import { useVirtualizer } from "@tanstack/react-virtual"
import { Controller, set, useForm } from 'react-hook-form'
import DialogEditPencairan from '../../../components/production/DialogEditPencairan'
import DialogTambahBarang from '../../../components/production/DialogTambahBarang'
import JurnalModal from '../../../components/acc/jurnal/JurnalModal'
import BkkBulkPrintTable from '../../../components/production/BkkBulkPrintTable'

const formatNumber = (value: string | number) => {
    if (!value) return "";

    const str = String(value);

    // split decimal
    const [int, dec] = str.replace(/\./g, "").split(",");

    const formattedInt = Number(int || 0).toLocaleString("id-ID");

    return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
};

const parseNumber = (value: string) => {
    return value.replace(/\./g, "");
};

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [jenis, setJenis] = useState<string>("")
    const [listData, setListData] = useState<any[]>([])
    const [listDataBkk, setListDataBkk] = useState<any[]>([])

    const [idDoc, setIdDoc] = useState<any>(null)
    const [openJurnal, setOpenJurnal] = useState<boolean>(false)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogEdit, setOpenDialogEdit] = useState<boolean>(false)
    const [openDialogPencairanJasa, setOpenDialogPencairanJasa] = useState<boolean>(false)
    const [openDialogTambahBiaya, setOpenDialogTambahBiaya] = useState<boolean>(false)
    const [openDialogTambahBarang, setOpenDialogTambahBarang] = useState<boolean>(false)
    const [openDialogPiutang, setOpenDialogPiutang] = useState<boolean>(false)
    const [selectedData, setSelectedData] = useState<any>(null)

    const [profitCenter, setProfitCenter] = useState<any>(null)
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [tglCair, setTglCair] = useState<string>(moment().format('YYYY-MM-DD'))

    const [tglAwalBkk, setTglAwalBkk] = useState<string>(moment().format('YYYY-MM-DD'))
    const [tglAkhirBkk, setTglAkhirBkk] = useState<string>(moment().format('YYYY-MM-DD'))

    const [search, setSearch] = useState("")
    useEffect(() => {
        getData(tabs)
        getProfitCenter()
    }, [])

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDataBkk = () => {
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list-bkk'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwalBkk,
                    tgl_akhir: tglAkhirBkk
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDataBkk(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getProfitCenter = () => {
        setListProfitCenter([])
        let url = apiUrl.apiUrl + '/acc/penyesuaian/list-profit-center'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProfitCenter(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        setProfitCenter(null)
        getData(newValue)
        switch (newValue) {
            case "0":
                setJenis("")
                break;
            case "7":
                setJenis("")
                getData("0")
                break;
            case "1":
                setJenis("JAHIT")
                break;
            case "2":
                setJenis("POTONG")
                break;
            case "3":
                setJenis("BORDIR")
                break;
            case "4":
                setJenis("LAINNYA")
                break;
            case "5":
                setJenis("PRINTING")
                break;
            default:
                break;
        }
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/production/jasa-work-order/delete/' + row.id
        axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    getData(tabs)
                    showToast("Data berhasil dihapus", "success")
                } else {
                    showToast(response.data.message, "error")
                }
            })
            .catch(error => {
                showToast(error.message, "error")
            })
    };
    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"Hapus"} title={"Hapus"} placement="top">
                    <IconButton onClick={() => onDelete(row)}>
                        <Icon icon={"mdi:trash"} color={"red"} />
                    </IconButton>
                </Tooltip>
                <Tooltip key={"Edit"} title={"Edit"} placement="top">
                    <IconButton onClick={() => {
                        setValue('wo_order_biaya_id', row.id)
                        setValue('keterangan', row.keterangan)
                        setSelectedData(row)
                        setOpenDialogEdit(true)
                    }}>
                        <Icon icon={"mdi:pencil"} color={"grey"} />
                    </IconButton>
                </Tooltip>
                <Tooltip key={"Jurnal"} title={"Lihat Jurnal"} placement="top">
                    <IconButton onClick={() => {
                        window.open(apiUrl.baseUrl + '/acc/mutasi-kas-bank/pdf/' + row.doc_id, '_blank')
                    }}>
                        <Icon icon={"mdi:document"} color={"grey"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const ActionButtonsLainnya = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"Hapus"} title={"Hapus"} placement="top">
                    <IconButton onClick={() => onDelete(row)}>
                        <Icon icon={"mdi:trash"} color={"red"} />
                    </IconButton>
                </Tooltip>
                <Tooltip key={"Edit"} title={"Edit"} placement="top">
                    <IconButton onClick={() => {
                        setValue('wo_order_biaya_id', row.id)
                        setValue('keterangan', row.keterangan)
                        setSelectedData(row)
                        setOpenDialogEdit(true)
                    }}>
                        <Icon icon={"mdi:pencil"} color={"grey"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const ActionButtonsBarangLainnya = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"Hapus"} title={"Hapus"} placement="top">
                    <IconButton onClick={() => onDelete(row)}>
                        <Icon icon={"mdi:trash"} color={"red"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const ActionButtonsBkk = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"a5"} title={"Cetak BKK A5"} placement="top">
                    <IconButton
                        onClick={() =>
                            window.open(
                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf/${row.id}`,
                                '_blank'
                            )
                        }
                    >
                        <Icon icon={"mdi:printer"} color={"grey"} />
                    </IconButton>
                </Tooltip>
                <Tooltip key={"a6"} title={"Cetak BKK A6"} placement="top">
                    <IconButton
                        onClick={() =>
                            window.open(
                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf-a6/${row.id}`,
                                '_blank'
                            )
                        }
                    >
                        <Icon icon={"mdi:printer"} color={"grey"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionDataBkk = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 80,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsBkk
                    row={row}
                />
            ),
        },
    ];

    const actionDataLainnya = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsLainnya
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const actionDataBarangLainnya = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsBarangLainnya
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'link',
            minWidth: 200,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 200,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenDialog(true);
                        }
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ];

    const filteredData = listData.filter((row) =>
        row.kode
            ?.toLowerCase()
            .includes(search.toLowerCase())
    )

    const parentRef = useRef(null)
    const columnCount = 3
    const rowCount = Math.ceil(filteredData.length / columnCount)
    const rowVirtualizer = useVirtualizer({
        count: rowCount,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 400,
        overscan: 5,
    })

    const handleApproveJahit = (row) => {
        let setapprove = 1;
        if (row.is_cek_jahit == 1) {
            setapprove = 0
        }
        approveWorkOrder(row, 'JAHIT', setapprove);
    }

    const handleApprovePotong = (row) => {
        let setapprove = 1;
        if (row.is_cek_potong == 1) {
            setapprove = 0
        }
        approveWorkOrder(row, 'POTONG', setapprove);
    }

    interface FormInputs {
        wo_order_biaya_id: any;
        tgl: any
        total: any
        accakun_bank_id: any // akun bank
        accakun_id: any // akun biaya
        keterangan: string;
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const approveWorkOrder = (row: any, mode: any, setapprove: any) => {
        const payload = {
            wo_order_id: row.id,
            mode: mode,
            setapprove: setapprove
        };

        const url = apiUrl.apiUrl + '/production/jasa-work-order/approve-wo'
        axios.post(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success")
                    setListData(prev => prev.map(item => item.id === row.id
                        ? { ...item, ...response.data.data }
                        : item))
                } else {
                    showToast(response.data.message, "error")
                }
            })
            .catch(error => {
                showToast(error.message, "error")
            })
    };

    const ApprovalCard = ({ row, onApproveJahit, onApprovePotong }) => {
        const approvedJahit = row?.is_cek_jahit == 1
        const approvedPotong = row?.is_cek_potong == 1
        const approvalDate = (approved, value) => {
            if (!approved) return 'Belum disetujui'
            const date = [value, row.updated_at].find(candidate =>
                candidate && moment(candidate).isValid())
            return date ? moment(date).format('DD/MM/YYYY HH:mm') : '—'
        }

        return (
            <Card sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden" }}>

                {/* IMAGE */}
                <Box sx={{ height: 160, overflow: "hidden" }}>
                    <Box
                        component="img"
                        src={row?.link || "https://placehold.co/400x300"}
                        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                </Box>

                <CardContent>

                    <Typography variant="caption">Kode Preview</Typography>
                    <Typography fontWeight="bold">
                        {row.kode}
                    </Typography>

                    <Divider sx={{ my: 1 }} />

                    <Grid container>
                        <Grid item xs={4}>
                            <Typography variant="caption">Qty</Typography>
                            <Typography fontWeight="bold">{row.qty} Pcs</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="caption">Qty Jahit</Typography>
                            <Typography fontWeight="bold" color="success.main">
                                {row.qty_jahit_selesai ?? 0} Pcs
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="caption">Qty Potong</Typography>
                            <Typography fontWeight="bold" color="success.main">
                                {row.qty_potong_selesai ?? 0} Pcs
                            </Typography>
                        </Grid>
                    </Grid>

                    <Stack direction="row" spacing={1} mt={2}>

                        <Button
                            fullWidth
                            size="small"
                            variant={approvedJahit ? "outlined" : "contained"}
                            color={approvedJahit ? "success" : "primary"}
                            startIcon={
                                approvedJahit
                                    ? <Icon icon="mdi:check-circle" />
                                    : <Icon icon="mdi:needle" />
                            }
                            onClick={() => onApproveJahit(row)}
                        >
                            {approvedJahit ? "Approved" : "Jahit"}
                        </Button>

                        <Button
                            fullWidth
                            size="small"
                            variant={approvedPotong ? "outlined" : "contained"}
                            color={approvedPotong ? "success" : "secondary"}
                            startIcon={
                                approvedPotong
                                    ? <Icon icon="mdi:check-circle" />
                                    : <Icon icon="mdi:content-cut" />
                            }
                            onClick={() => onApprovePotong(row)}
                        >
                            {approvedPotong ? "Approved" : "Potong"}
                        </Button>

                    </Stack>

                    <Stack direction="row" spacing={1} mt={1}>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" color="text.secondary" display="block">Approval Jahit</Typography>
                            <Typography variant="caption">{approvalDate(approvedJahit, row.approved_jahit_at)}</Typography>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="caption" color="text.secondary" display="block">Approval Potong</Typography>
                            <Typography variant="caption">{approvalDate(approvedPotong, row.approved_potong_at)}</Typography>
                        </Box>
                    </Stack>

                </CardContent>
            </Card>
        )
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='JASA WORK ORDER' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-end"
                        >
                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Awal"
                                    type="date"
                                    value={tglAwal}
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Akhir"
                                    type="date"
                                    value={tglAkhir}
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<Icon icon="mdi:magnify" />}
                                    onClick={() => getData(tabs)}
                                    sx={{ height: 56 }}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Work Order' />
                            <Tab value='7' label='Approval Jahit & Potong' />
                            {/* <Tab value='8' label='Pricelist Model' /> */}
                            <Tab value='1' label='Jasa Jahit' />
                            <Tab value='2' label='Jasa Potong' />
                            <Tab value='3' label='Jasa Bordir' />
                            <Tab value='5' label='Jasa Printing' />
                            <Tab value='4' label='Jasa Lainnya' />
                            <Tab value='9' label='Barang Lainnya' />
                            <Tab value='6' label='Cetak Slip Gaji' />
                            <Tab value='10' label='Cetak BKK' onClick={getDataBkk} />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} rowStyleRules={[
                                { field: 'harga_jahit', operator: '==', value: 0, color: '#ffbe76' },
                                { field: 'harga_potong', operator: '==', value: 0, color: '#ffbe76' },
                                { field: 'harga_bordir', operator: '==', value: 0, color: '#ffbe76' },
                            ]} convertNumeric={['harga_jahit', 'harga_potong', 'harga_bordir', 'cair_jahit', 'cair_potong', 'cair_bordir', 'cair_lainnya']}
                                rowClick={(e: any) => {
                                    const item = e.data
                                    setOpenDialog(true)
                                    setSelectedData(item)
                                }}
                                customRender={convertComponent}
                            />
                        </TabPanel>
                        <TabPanel value='1'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setOpenDialogPencairanJasa(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                PENCAIRAN
                            </Button>

                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setOpenDialogPiutang(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                PIUTANG KARYAWAN
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} hiddenColumns={['doc_id']} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setOpenDialogPencairanJasa(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                PENCAIRAN
                            </Button>

                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setOpenDialogPiutang(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                PIUTANG KARYAWAN
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} hiddenColumns={['doc_id']} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setJenis("BORDIR")
                                        setOpenDialogTambahBiaya(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                            >
                                TAMBAH BIAYA
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} hiddenColumns={['doc_id']} />
                        </TabPanel>
                        <TabPanel value='4'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setJenis("LAINNYA")
                                        setOpenDialogPencairanJasa(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                PENCAIRAN
                            </Button>

                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setJenis("LAINNYA")
                                        setOpenDialogTambahBiaya(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                TAMBAH BIAYA
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} hiddenColumns={['accprofitcenter_id', 'wo_order_id', 'doc_id']} actions={actionDataLainnya} />
                        </TabPanel>
                        <TabPanel value='5'>
                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setJenis("PRINTING")
                                        setOpenDialogTambahBiaya(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                            >
                                TAMBAH BIAYA
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} hiddenColumns={['doc_id']} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='6'>
                            <Grid
                                container
                                spacing={3}
                                alignItems="flex-end"
                            >
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        fullWidth
                                        label="Tanggal Cair"
                                        type="date"
                                        value={tglCair}
                                        onChange={(e) => setTglCair(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        value={profitCenter}
                                        options={listProfitCenter}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama_profitcenter ?? ""}
                                        onChange={(_, val) => setProfitCenter(val)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Profit Center"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={"auto"}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={<Icon icon="mdi:printer" />}
                                        disabled={!profitCenter}
                                        onClick={() => window.open(`${apiUrl.baseUrl}/production/jasa-work-order/slip-gaji/${tglCair}/${profitCenter?.id}`, '_blank')}
                                        sx={{ height: 56 }}
                                    >
                                        CETAK SLIP GAJI (NOTA)
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={"auto"}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={<Icon icon="mdi:printer" />}
                                        disabled={!profitCenter}
                                        onClick={() => window.open(`${apiUrl.baseUrl}/production/jasa-work-order/slip-gaji-a4/${tglCair}/${profitCenter?.id}`, '_blank')}
                                        sx={{ height: 56 }}
                                    >
                                        CETAK SLIP GAJI (A4)
                                    </Button>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value='7'>
                            <Grid container spacing={2}>
                                {/* FILTER (Static UI Only) */}
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Cari Kode Preview"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </Grid>

                                {/* CARD LIST */}
                                <Grid item xs={12}>
                                    <Box
                                        ref={parentRef}
                                        sx={{
                                            height: "70vh",
                                            overflow: "auto",
                                            position: "relative"
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                height: `${rowVirtualizer.getTotalSize()}px`,
                                                position: "relative"
                                            }}
                                        >
                                            {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                                                const items = filteredData.slice(
                                                    virtualRow.index * columnCount,
                                                    virtualRow.index * columnCount + columnCount
                                                )

                                                return (
                                                    <Box
                                                        key={virtualRow.index}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            transform: `translateY(${virtualRow.start}px)`,
                                                            paddingBottom: 0
                                                        }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            {items.map((row) => (
                                                                <Grid item xs={12} sm={6} md={4} key={row.id}>
                                                                    <ApprovalCard
                                                                        row={row}
                                                                        onApproveJahit={handleApproveJahit}
                                                                        onApprovePotong={handleApprovePotong}
                                                                    />
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Box>
                                                )
                                            })}
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </TabPanel>
                        <TabPanel value='8'>
                            <MsiDatagrid array={listData} hiddenColumns={['id']} />
                        </TabPanel>
                        <TabPanel value='9'>
                            <Button
                                variant="contained"
                                color="inherit"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    if (tabs != "0") {
                                        setJenis("LAINNYA")
                                        setOpenDialogTambahBarang(true)
                                    } else {
                                        showToast("Pilih tab yang mau dicairkan", "error")
                                    }
                                }}
                                sx={{ mr: 1 }}
                            >
                                TAMBAH BIAYA
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} hiddenColumns={['accprofitcenter_id', 'wo_order_id', 'doc_id']} actions={actionDataBarangLainnya} />
                        </TabPanel>
                        <TabPanel value='10'>
                            <Grid
                                container
                                spacing={3}
                                alignItems="flex-end"
                            >
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        fullWidth
                                        label="Tanggal Awal"
                                        type="date"
                                        value={tglAwalBkk}
                                        onChange={(e) => setTglAwalBkk(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        fullWidth
                                        label="Tanggal Akhir"
                                        type="date"
                                        value={tglAkhirBkk}
                                        onChange={(e) => setTglAkhirBkk(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={<Icon icon="mdi:magnify" />}
                                        onClick={() => getDataBkk()}
                                        sx={{ height: 56 }}
                                    >
                                        Cari Data
                                    </Button>
                                </Grid>
                            </Grid>
                            <BkkBulkPrintTable rows={listDataBkk} />
                            {/* <MsiDatagrid array={listDataBkk} convertNumeric={['total']} hiddenColumns={['accprofitcenter_id', 'wo_order_id', 'doc_id']} actions={actionDataBkk} /> */}
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <DialogEditHargaJasa
                key={selectedData?.id}
                open={openDialog}
                data={selectedData}
                onClose={() => {
                    setOpenDialog(false)
                    getData(tabs)
                }}
            />
            <DialogPencairanJasa
                key={999999999}
                open={openDialogPencairanJasa}
                jenis={jenis}
                onClose={() => {
                    setOpenDialogPencairanJasa(false)
                    getData(tabs)
                }}
            />
            <DialogTambahBiaya
                key={666}
                open={openDialogTambahBiaya}
                jenis={jenis}
                onClose={() => {
                    setOpenDialogTambahBiaya(false)
                    getData(tabs)
                }}
            />
            <DialogTambahBarang
                key={666}
                open={openDialogTambahBarang}
                jenis={jenis}
                onClose={() => {
                    setOpenDialogTambahBarang(false)
                    getData(tabs)
                }}
            />
            <DialogPiutang
                key={777}
                open={openDialogPiutang}
                jenis={jenis}
                onClose={() => {
                    setOpenDialogPiutang(false)
                    getData(tabs)
                }}
            />
            <DialogEditPencairan
                key={777}
                open={openDialogEdit}
                selectedData={selectedData}
                jenis={jenis}
                onClose={() => {
                    setOpenDialogEdit(false)
                    getData(tabs)
                }}
            />

            <JurnalModal
                open={openJurnal}
                onClose={() => setOpenJurnal(false)}
                id={idDoc}
                tabel={'wo_order_biaya'}
            />
        </Grid>
    )
}
